// Shared by index.jsx (page-ready signalling) and features.jsx (route rendering) so the two can
// never drift apart on the pathname.
export const isAcceptInvitationRoute = (pathname = window.location.pathname) => (
  pathname.toLowerCase().startsWith('/pmaxlite/acceptinvitation')
);
